/**
 * 兼容层：仅为旧模块保留命名。
 * 颜色与交互参数唯一来源为 solidworks-default-preset.ts。
 */

import { solidworksDefaultPreset } from './solidworks-default-preset';

export const SW_HOVER_COLOR = solidworksDefaultPreset.selection3D.hoverEdgeColor;
export const SW_SELECTED_COLOR = solidworksDefaultPreset.selection3D.selectedFaceFill;
export const SW_VISIBLE_EDGE_COLOR = solidworksDefaultPreset.model3D.visibleEdgeColor;
export const SW_VISIBLE_EDGE_OPACITY = solidworksDefaultPreset.model3D.visibleEdgeOpacity;
export const SW_VERTEX_CUE_COLOR = solidworksDefaultPreset.selection3D.vertexCueColor;
export const SW_VERTEX_CUE_RADIUS = solidworksDefaultPreset.selection3D.vertexCueRadius;
export const SW_EDGE_PICK_THRESHOLD_PX = solidworksDefaultPreset.picking.edgePickThresholdPx;
export const SW_VERTEX_PICK_THRESHOLD_PX = solidworksDefaultPreset.picking.vertexPickThresholdPx;
export const SW_PICK_OCCLUSION_EPSILON = solidworksDefaultPreset.picking.occlusionEpsilon;

export const SW_SELECTION_BOX_DASH_SIZE = solidworksDefaultPreset.selectionBox.dashSize;
export const SW_SELECTION_BOX_GAP_SIZE = solidworksDefaultPreset.selectionBox.gapSize;

export const SW_SELECTION_HANDLE_BORDER_COLOR = solidworksDefaultPreset.selectionHandle.borderColor;
export const SW_SELECTION_HANDLE_FILL_COLOR = solidworksDefaultPreset.selectionHandle.fillColor;
export const SW_SELECTION_HANDLE_SIZE = solidworksDefaultPreset.selectionHandle.size;
export const SW_SELECTION_HANDLE_HIT_SIZE = solidworksDefaultPreset.selectionHandle.hitSize;
